<template>
  <div>
    <v-info-form :title="title" @close="cancel()">
      <v-panel-title  @click="switchTitle()" :value="isLoaded" :caption="isLoaded  ? 'Кратко ' : 'Еще '" :expandable="(!isLoaded && this.lastItems.length > 0) || (this.topCount <= this.lastItems.length && this.lastItems.length > 0)">
        <template v-for="item in topItems">
          <v-layout column>
            <v-flex>
             Номер сводного исполнительного производства: <b>{{formats.blank(item.totalNumber)}}</b>
            </v-flex>
            <v-flex>
             Номер исполнительного производства: <b>{{item.enforcementNumber}}</b>
            </v-flex>
            <v-flex>
              Задолженность по документу: {{formats.blank(item.amount, this.formatCurrency)}}
            </v-flex>
            <v-flex>
              Остаток задолженности: <b>{{formats.blank(item.remaining, this.formatCurrency)}}</b>
            </v-flex>
            <v-flex>
              <b>{{item.executionObject}}</b>
            </v-flex>
            <v-flex>
              Исполнительный документ:
              <v-flex pl-2 v-if="item.document">
                <b>{{item.document.type}}</b>
                <div>
                Номер <b>{{item.document.number}}</b> от <b>{{formats.blank(item.document.date, formats.formatDate)}}</b>
                </div>
              </v-flex>
            </v-flex>
            <v-flex>
              Взыскатель:
              <v-flex pl-2 v-if="item.collector && !item.collectorRef">ИНН:<b>{{formats.formatInn(item.collector)}}</b></v-flex>
              <v-flex v-if="item.collectorRef" pl-2>
                <span v-html="formatReference(item.collectorRef)"></span>
                <v-component :is="renderFlags(item.collectorRef.flags, true)" />
              </v-flex>
            </v-flex>
            <v-flex>
              Должник:
              <v-flex v-if="item.debtorRef" pl-2>
                <span v-html="formatReference(item.debtorRef)"></span>
                <v-component :is="renderFlags(item.debtorRef.flags, true)" />
              </v-flex>              
              <v-flex pl-2>По ФССП:</v-flex>
              <v-flex pl-3 v-if="item.debtor">{{item.debtorName}} ({{item.debtor}})</v-flex>
              <v-flex pl-3>
                Адрес: {{item.debtorAddress}}
              </v-flex>
            </v-flex>
            <v-flex>
              Дело в производстве в:
              <v-flex pl-2><b>{{item.department}}</b></v-flex>
              <v-flex pl-2>
               Адрес <b>{{item.departmentAddress}}</b>
             </v-flex>
            </v-flex>
            <v-flex>
              Актуальность с <b>{{formats.blank(item.fileDate, formats.formatDate)}}</b> по {{formats.blank(item.lastDate, formats.formatDate)}}
            </v-flex>
          </v-layout>
        </template>
        <v-flex pt-2> История изменений: </v-flex>
        <v-flex pl-2 v-if="isLoaded && this.lastItems.length === 0">Нет данных</v-flex>
        <template v-for="item in lastItems">
          <v-flex pl-2 pb-2>
            <v-layout row>
              <v-layout column>
                <v-flex v-if="isInDiff(item, 'totalNumber')">
                 Номер сводного исполнительного.производства: <b>{{formats.blank(item.totalNumber)}}</b>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'enforcementNumber')">
                 Номер исполнительного производства: <b>{{formats.blank(item.enforcementNumber)}}</b>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'stage')">
                 Статус: <b>{{item.stage ? (item.stage == 1 ? 'Открыто' : 'Закрыто') : '-'}}</b>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'amount')">
                  Задолженность по документу: {{formats.blank(item.amount, this.formatCurrency)}}
                </v-flex>
                <v-flex v-if="isInDiff(item, 'remaining')">
                  Остаток задолженности: <b>{{formats.blank(item.remaining, this.formatCurrency)}}</b>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'executionObject')">
                  <b>{{formats.blank(item.executionObject)}}</b>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'document')">
                  Исп. документ: <span v-if="item.document" pl-2>-</span>
                  <v-flex v-if="item.document" pl-2>
                    <b>{{formats.blank(item.document.type)}}</b>
                    <div>
                    Номер <b>{{formats.blank(item.document.number)}}</b> от <b>{{formats.blank(item.document.date, formats.formatDate)}}</b>
                    </div>
                  </v-flex>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'collector')">
                  Взыскатель:
                  <v-flex pl-2><b>ИНН: {{formats.blank(formats.formatInn(item.collector))}}</b></v-flex>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'debtor') || isInDiff(item, 'debtorName') || isInDiff(item, 'debtorAddress')">
                  Должник:
                  <v-flex pl-2 v-if="isInDiff(item, 'debtor')">
                    ИНН:<b>{{formats.blank(formats.formatInn(item.debtor))}}</b>
                  </v-flex>
                  <v-flex pl-2 v-if="isInDiff(item, 'debtorName')">
                    Название<b>{{formats.blank(item.debtorName)}}</b>
                  </v-flex>
                  <v-flex pl-2 v-if="isInDiff(item, 'debtorAddress')">
                    Адрес: <b>{{formats.blank(item.debtorAddress)}}</b>
                  </v-flex>
                </v-flex>
                <v-flex v-if="isInDiff(item, 'department') || isInDiff(item, 'departmentAddress')">
                  Дело в производстве в:
                  <v-flex pl-2 v-if="isInDiff(item, 'departmentAddress')">
                    <b>{{formats.blank(item.department)}}</b>
                  </v-flex>
                  <v-flex pl-2 v-if="isInDiff(item, 'departmentAddress')">
                   Адрес <b>{{formats.blank(item.departmentAddress)}}</b>
                 </v-flex>
                </v-flex>
              </v-layout>
              <v-flex pb-0 align-end>{{formats.blank(item.fileDate, formats.formatDate)}}</v-flex>          
            </v-layout>
          </v-flex>
        </template>
        <div
          v-show="isLoading"
          class="text-xs-center">
              <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>      
      </v-panel-title>  
    </v-info-form>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import apimix from '../common/apimix'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import vInfoForm from '../common/InfoForm'
  import vPanelTitle from '../info/PanelTitle'
  import vPanelText from '../info/PanelText'

  export default {
    name: 'v-enforcement-form',
    components: {vPanelTitle, vPanelText, vInfoForm},
    mixins: [apimix],
    data: () => ({
      items: [],
      topCount: 10,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object,
        default: () => {}
      }
    },
    mounted () {
      if (this.model) {
        this.items = [this.model]
      }
      this.fetchData()
    },
    watch: {
      model: function (newVal, oldVal) {
        if (newVal) {
          this.items = [newVal]
        }
        this.fetchData()
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderFlags: 'renderFlags'
      }),
      title () {
        return `${this.model.enforcementNumber ? this.model.enforcementNumber : 'Исполнительное производство'}`
      },
      topItems () {
        return this.items.slice(0, 1)
      },
      lastItems () {
        return this.items.slice(1)
      }
    },
    methods: {
      cancel () {
        this.$emit('close')
      },
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + ' р.' : ''
      },
      isInDiff (item, fieldName) {
        return Object.keys(item).includes(fieldName)
      },
      fetchData () {
        if (!this.model) {
          return
        }
        this.fetchItems()
      },
      formatReference (ref) {
        return ref && this.renderReference(ref, '_blank') || ''
      },
      switchTitle () {
        if (!this.isLoaded) {
          this.fetchItems()
        } else {
          this.isLoaded = false
          this.loadedPages = 0
          this.items = this.topItems
        }
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении изменений исполнтьельного производсва '})
        }
        id = id.replaceAll('/', '%2F')
        id = encodeURIComponent(id)
        server.openApiGetParams(
          '/openapi/enforcements/' + id,
          {
            size: this.topCount,
            page: this.loadedPages
          },
          cb,
          cbError)
      },
      fetchItems () {
        if (!this.isLoading) {
          this.isLoading = true
          this.getItems(this.model.enforcementNumber, (data) => {
            if (data.number > 0) {
              this.items = this.items.concat(data.content)
            } else {
              this.items = data.content
            }
            this.loadedPages = !data.last ? data.number + 1 : data.number
            this.isLoading = false
            this.isLoaded = data.last
          })
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// EnforcementForm.vue?298705f0